import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter/wght.css';
import { WelcomeApp } from './WelcomeApp';
import { injectTokensIntoHead } from '../shared/tokens';
import { trackWelcomeViewed } from './analytics';
import '../shared/styles/globals.css';
import './welcome.css';

injectTokensIntoHead();
trackWelcomeViewed();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Welcome root element not found');

createRoot(rootEl).render(
  <StrictMode>
    <WelcomeApp />
  </StrictMode>,
);
